import { Stack, Tab, Tabs, Typography } from '@mui/material';
import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
  useNavigate
} from '@tanstack/react-router';

import { SyntheticEvent } from 'react';

const TABS = [
  { label: 'Tables', testId: 'tabTables', to: '/db-insights/tables' },
  { label: 'Schema Drift', testId: 'tabSchemaDrift', to: '/db-insights/drift' },
  {
    label: 'Collation Mismatches',
    testId: 'tabCollationMismatches',
    to: '/db-insights/collations'
  },
  {
    label: 'Slow Queries',
    testId: 'tabSlowQueries',
    to: '/db-insights/slow-queries'
  }
] as const;

const DbInsightsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const onTabChange = (_event: SyntheticEvent, value: string) =>
    navigate({ to: value });

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>DB Insights</Typography>

      <Tabs
        onChange={onTabChange}
        value={
          TABS.find(tab => location.pathname.startsWith(tab.to))?.to ??
          TABS[0].to
        }>
        {TABS.map(tab => (
          <Tab
            data-testid={tab.testId}
            key={tab.to}
            label={tab.label}
            value={tab.to}
          />
        ))}
      </Tabs>

      <Outlet />
    </Stack>
  );
};

export const Route = createFileRoute('/db-insights')({
  beforeLoad: () => {
    if (localStorage.getItem('isAdmin') !== '1') {
      throw redirect({ to: '/organizations' });
    }
  },
  component: DbInsightsLayout
});
